<template>
  <div class="store" >
    <el-row class="cover-store">
      <el-button
      type="primary"
      size="mini"
      @click="handleAdd"
      style="margin-top: 10px"
      >新增</el-button
    >
      <el-button type="primary" size="mini" @click="onShowSkuCoverSetting">补位SKU设置</el-button>
      </el-row>
    <el-divider></el-divider>
    <el-table
      ref="tableRef"
      :data="goodsData"
      highlight-current-row
      style="width: 100%; margin-top: 10px"
      :max-height="maxHeight"
    >
    <!-- <el-table-column type="index" label="序号" width="80" align="center" /> -->
        <el-table-column type="sort" label="序号" width="80" align="center" >
          <template slot-scope="scope">
            <div class="merchant-name">
              <span class="name">{{ scope.row.sort }}</span>
              <span v-if="scope.row.id">
                <i
                  class="el-icon-edit"
                  style="margin-left: 10px"
                  @click="handleClickSort(scope.row)"
                ></i> 
              </span>
            </div>
          </template>
      </el-table-column>
      <el-table-column
        prop="merchantName"
        label="商户名称"
        width="200"
        align="center"
      />
      <el-table-column prop="shopName" label="店铺名" align="center" />
      <el-table-column label="店铺logo" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.shopLogo"
            :src="scope.row.shopLogo"
            alt=""
            style="width: 60px; height: 60px"
          />
        </template>
      </el-table-column>
      <el-table-column label="推荐商品" align="center" width="500">
        <template slot-scope="scope">
          <div
            class="goods-info"
            v-if="
              scope.row.goodsSkuTitle ||
              scope.row.goodsSkuName ||
              scope.row.specification ||
              scope.row.factory ||
              scope.row.approvalNumber
            "
          >
            <img
              class="goods-info-left"
              :src="scope.row.goodsSkuImage || avater"
              alt=""
            />
            <div class="goods-info-right">
              <div style="display: flex;">
                <span class="color-95 text">商品标题</span>
                <span class="color-26  text-ellipsis">{{
                  scope.row.goodsSkuTitle || "--"
                }}</span>
              </div>

              <div style="display: flex;">
                <span class="color-95 text">商品名称</span>
                <span class="color-26">{{
                  scope.row.goodsSkuName || "--"
                }}</span>
              </div>

              <div style="display: flex">
                <div
                  class="color-95 text"
                  style="width: 48px; text-align-last: justify"
                >
                  规格
                </div>
                <span class="color-26">{{
                  scope.row.specification || "--"
                }}</span>
              </div>
              <div style="display: flex;">
                <p class="color-95 text">生产厂家</p>
                <p class="color-26 text-ellipsis">{{ scope.row.factory || "--" }}</p>
              </div>
              <p>
                <span class="color-95 text">批准文号</span>
                <span class="color-26">{{
                  scope.row.approvalNumber || "--"
                }}</span>
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <p
            @click="handleEdit(scope.row)"
            style="cursor: pointer; margin-right: 10px"
          >
            选择商户及商品
        </p>
          <p
            @click="handleDelete(scope.row,scope.$index)"
            :style="{
              color:  'red',
              cursor:  'pointer',
            }"
            >删除</p
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增/编辑 -->
    <DlgAddGoods
      ref="addGoodsRef"
      :type="goodsType"
      @refreshList="getGoodsList"
    />
        <!-- 补位设置 -->
     <el-dialog title="SKU补位设置" :visible.sync="showSkuCoverSetting" width="70%" @close="onCloseSkuCoverSetting">
      <SaleKickedCoverSetting  :visible.sync="showSkuCoverSetting"/>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCloseSkuCoverSetting">取消</el-button>
        <!-- <el-button size="small" type="primary" @click="onSubmit"
          >确认</el-button
        > -->
      </span>
    </el-dialog>
    <setSort ref="setSort"  @refreshList="getGoodsList" :appendToBody="true"/>

  </div>
</template>

<script>
import avater from "/public/img/default.png";
import DlgAddGoods from "../components/dlgAddGoods";
import SaleKickedCoverSetting from "../components/saleKickedCoverSetting.vue";
import {
  getRecommendGoodsList,
  deleteRecommendGoods,
} from "@/api/recommendationHome";
import setSort from "../components/setSort";
export default {
  props: {},
  components: {
    DlgAddGoods,
    SaleKickedCoverSetting,
    setSort
  },
  data() {
    return {
      avater: avater,
      goodsData: [],
      goodsType: 2,
      maxHeight:0,
      showSkuCoverSetting: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getWindowView();
    this.getGoodsList();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    handleClickSort(row) {
      this.$refs.setSort.show(row,'goods');
    },
    getWindowView() { 
      let innerHeight = window.innerHeight; //获取页面高度 
      let headHeight = 300; 
      let maxHeight = innerHeight -  headHeight; 
      this.maxHeight = maxHeight;
        // console.log( this.maxHeight)
    },
    getGoodsList() {
      getRecommendGoodsList({ type: this.goodsType }).then((res) => {
        if (res.code == 0) {
          this.goodsData = res.data;
        }
      });
    },
    handleAdd() {
      this.goodsData.push({ add: true });
      this.$nextTick(() => {
        this.$refs.tableRef.bodyWrapper.scrollTop =
          this.$refs.tableRef.bodyWrapper.scrollHeight;
      });
    },
    handleEdit(row) {
      this.$refs.addGoodsRef.id = row.id;
      this.$refs.addGoodsRef.shopId = row.shopId;
      this.$refs.addGoodsRef.shopName = row.merchantName;
      this.$refs.addGoodsRef.dialogVisible = true;
    },
    handleDelete(row, index) {
      if (row.add){
        this.goodsData.splice(index, 1);
        return; 
      }
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteRecommendGoods(row.id);
        })
        .then(() => {
          this.getGoodsList();
          this.$message.success("删除成功");
        });
    },
    /** sku补位设置 */
    onShowSkuCoverSetting() {
      this.showSkuCoverSetting = true
    },
    /**关闭sku补位设置 */
    onCloseSkuCoverSetting() {
      this.showSkuCoverSetting = false
    }
  },
};
</script>
<style lang="scss" scoped>
.store {
  .merchant-name {
    display: flex;
    align-items: center;
    justify-content: center;
    .name {
      flex: 1;
    }
  }
  .tool-bar {
    display: flex;
    justify-content: center;
  }
  .goods-info {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    &-left {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
    &-right {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 260px;
      .text-ellipsis {
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    p {
      margin: 0;
      height: 18px;
    }
  }

  .color-95 {
    color: #959595;
    margin-right: 10px !important;
  }
  .color-26 {
    color: #262626;
  }
}
</style>
